export default "__VITE_ASSET__tij6gMu6__"